import { Mapper } from "../../../../base/utils/mapper";
import { OrganizationModel } from "../../../../domain/models/configuration/type-organization.model";
import { OrganizationEntity } from "../entities/organization.entity";


export class OrganizationImplementationRepositoryMapper extends Mapper<OrganizationEntity, OrganizationModel> {
    mapFrom(param: OrganizationEntity): OrganizationModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: OrganizationModel): OrganizationEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}